import React, {useEffect, useState} from 'react'



const THC = (props) => {

    console.log(props.match.params.location)

    let location = props.match.params.location

    const [desserts, setDesserts] = useState([])

    const thcMenu = {
        core: [
            {
                vendor: 'Foundry',
                name: 'Strawbery Fields',
                type: '5mg Delta 9-THC',
                size: '12oz',
                price:'10',
                description: 'Real cane sugar with mineral water and natural strawberry extract with hemp derived Delta-9 THC.',
                image: 'https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/foundry.png'

            },
            {
                vendor: 'BLNCD',
                name: 'Yuzu Ginger – THC Sparkling Water',
                type: '5mg Delta 9-THC',
                size: '12oz',
                price:'10',
                description:"Bubbly, Zero calories. Zero sugar. Zero alcohol. Zero aftertaste.",
                image: 'https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/BLNCD_YuzuGinger_-2.png'
            },
            {
                vendor: 'Trail Magic',
                name: 'Half & Half',
                type: '5mg Delta 9-THC',
                size: '12oz',
                price:'10',
                description: "Half iced tea and half lemonade made with sparkling water, lemons, tea cane sugar and hemp-derived Delta-9 THC.",
                image: 'https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/trailmagic.png'
            }
        ],
        edenPraire: [
            {
                vendor: 'Foundry',
                name: 'Strawbery Fields',
                type: '5mg Delta 9-THC',
                size: '12oz',
                price:'10',
                description: 'Real cane sugar with mineral water and natural strawberry extract with hemp derived Delta-9 THC.',
                image: 'https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/foundry.png'

            },
            
            {
                vendor: 'Wikid',
                name: 'Bramble',
                type: '5mg Delta 9-THC',
                size: '12oz',
                price:'10',
                description:"Blackberry sparkling beverage with hints of raspberry and strawberry. The perfect sparkling beverage to compliment dinner.",
                image: 'https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/BLNCD_YuzuGinger_-2.png'
            },
            {
                vendor: 'Trail Magic',
                name: 'Half & Half',
                type: '5mg Delta 9-THC',
                size: '12oz',
                price:'10',
                description: "Half iced tea and half lemonade made with sparkling water, lemons, tea cane sugar and hemp-derived Delta-9 THC.",
                image: 'https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/trailmagic.png'
            }
        ],
        duluthOnly: [
            {
                vendor: 'Bent Paddle',
                name: 'THC+ Mango Tangerine',
                type: '5mg Delta 9-THC + 5mg CBD',
                size: '12oz',
                price:'10',
                description: 'Mango and tangerine flavored sparking water with hemp-derived THC and CBD.',
                image: 'https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/mango-thc.png'
            }
        ],
        downtownOnly: [
            {
                vendor: 'Insight',
                name: 'Flavor Pixels Orange Creamsicle',
                type: '10mg Delta 9 THC + 20mg CBD',
                size: '12oz',
                price:'10',
                description: 'Pixelate Your Brain!',
                image: 'https://pizza-luce-styles.s3.us-east-2.amazonaws.com/img/mango-thc.png'
            }
        ]
    }

    useEffect(() => {
        const dessertMenuId = '604a819b88b21f0999b915d3'
        const url = `https://beta.pizzaluce.com/api/menu/${dessertMenuId}/full`
        const getData = async () => {
            try {
                const response = await fetch(url)
                const json = await response.json()
                setDesserts(json)
            } catch (error) {
                console.log("error", error)
            }
        }; getData()
    }, [])

    const getPrice = (number) => {
        let price = parseFloat(number)
        return price
    }

    console.log(desserts)

    const layoutPL1 = () => {
        let beverages = thcMenu.core.concat(thcMenu.downtownOnly)
        let beverages2 = thcMenu.core

        return (
            <div className="thc-giftcards-two-column-pl1">
                <div className="na-col-left">
                    <div className="thc-seltzers">
                        {beverages.map(item => (
                            <div className="thc-item">
                                <div className="thc-name">
                                    {item.vendor} {item.name} <span> • {item.price}</span>
                                </div>
                                
                                <div className="thc-size">
                                    {item.size} • {item.type}
                                </div>
                                <div className="thc-description">
                                    {item.description}
                                </div>
                                
                            </div>
                        ))}
                    </div>

                    <div className="disclaimer">
                        <div className="thc-effects-headline">
                            First time?
                        </div>
                        <div className="thc-effects-text">
                            5mg of THC is considered to a be "low dose" but effects can vary by the individual. If you're worried, go slow and share a can with a friend. Most guests see results like mild relaxation and creativity.
                        </div>
                    </div>
                </div>
                <div className="na-col-right">
                
                </div>
            </div>
        )
    }
    const layoutPL2 = () => {
        let beverages = thcMenu.core

        return (
            <div className="thc-giftcards-two-column-pl2">
                <div className="na-col-left">
                    <div className="thc-seltzers">
                    {beverages.map(item => (
                            <div className="thc-item">
                                <div className="thc-name">
                                    {item.vendor} {item.name} <span> • {item.price}</span>
                                </div>
                                <div className="thc-size">
                                    {item.size} • {item.type}
                                </div>
                                <div className="thc-description">
                                    {item.description}
                                </div>
                               
                            </div>
                        ))}
                    </div>
                    <div className="disclaimer">
                        <div className="thc-effects-headline">
                            First time?
                        </div>
                        <div className="thc-effects-text">
                        5mg of THC is considered to a be "low dose" but effects can vary by the individual. If you're worried, go slow and share a can with a friend. Most guests see results like mild relaxation and creativity.
                        </div>
                    </div>
                </div>
                <div className="na-col-right">
            
                </div>
            </div>
        )
    }
    const layoutPL3 = () => {
        let beverages = thcMenu.core.concat(thcMenu.duluthOnly)

        return (
            <div className="thc-giftcards-two-column-pl3">
                <div className="na-col-left">
                    <div className="thc-seltzers">
                    {beverages.map(item => (
                            <div className="thc-item">
                                <div className="thc-name">
                                    {item.vendor} {item.name} <span> • {item.price}</span>
                                </div>
                                <div className="thc-size">
                                    {item.size} • {item.type}
                                </div>
                                <div className="thc-description">
                                    {item.description}
                                </div>
                               
                            </div>
                        ))}
                    </div>
                    <div className="disclaimer">
                        <div className="thc-effects-headline">
                            First time?
                        </div>
                        <div className="thc-effects-text">
                            5mg of THC is considered to a be "low dose" but effects can vary by the individual. If you're worried, go slow and share a can with a friend. Most guests see results like mild relaxation and creativity.
                        </div>
                    </div>
                    
                </div>
                <div className="na-col-right">

                </div>
            </div>
        )
    }
    const layoutPL4 = () => {
        let beverages = thcMenu.core

        return (
            <div className="thc-giftcards-two-column-pl4">
                <div className="na-col-left">
                    <div className="thc-seltzers">
                    {beverages.map(item => (
                            <div className="thc-item">
                                <div className="thc-name">
                                    {item.vendor} {item.name} <span> • {item.price}</span>
                                </div>
                                <div className="thc-size">
                                    {item.size} • {item.type}
                                </div>
                                <div className="thc-description">
                                    {item.description}
                                </div>
                               
                            </div>
                        ))}
                    </div>
                    <div className="disclaimer">
                        <div className="thc-effects-headline">
                            First time?
                        </div>
                        <div className="thc-effects-text">
                            5mg of THC is considered to a be "low dose" but effects can vary by the individual. If you're worried, go slow and share a can with a friend. Most guests see results like mild relaxation and creativity.
                        </div>
                    </div>
                </div>
                <div className="na-col-right">

                </div>
            </div>
        )
    }
    const layoutPL5 = () => {
        let beverages = thcMenu.core

        return (
            <div className="thc-giftcards-two-column-pl5">
                <div className="na-col-left">
                    <div className="thc-seltzers">
                    {beverages.map(item => (
                            <div className="thc-item">
                                <div className="thc-name">
                                    {item.vendor} {item.name} <span> • {item.price}</span>
                                </div>
                                <div className="thc-size">
                                    {item.size} • {item.type}
                                </div>
                                <div className="thc-description">
                                    {item.description}
                                </div>
                                
                            </div>
                        ))}
                    </div>
                    <div className="disclaimer">
                        <div className="thc-effects-headline">
                            First time?
                        </div>
                        <div className="thc-effects-text">
                            5mg of THC is considered to a be "low dose" but effects can vary by the individual. If you're worried, go slow and share a can with a friend. Most guests see results like mild relaxation and creativity.
                        </div>
                    </div>
                </div>
                <div className="na-col-right">

                </div>
            </div>
        )
    }
    const layoutPL6 = () => {
        let beverages = thcMenu.core

        return (
            <div className="thc-giftcards-two-column-pl6">
                <div className="na-col-left">
                    <div className="thc-seltzers">
                    {beverages.map(item => (
                            <div className="thc-item">
                                <div className="thc-name">
                                    {item.vendor} {item.name} <span> • {item.price}</span>
                                </div>
                                <div className="thc-size">
                                    {item.size} • {item.type}
                                </div>
                                <div className="thc-description">
                                    {item.description}
                                </div>
                                
                            </div>
                        ))}
                    </div>
                    <div className="disclaimer">
                        <div className="thc-effects-headline">
                            First time?
                        </div>
                        <div className="thc-effects-text">
                            5mg of THC is considered to a be "low dose" but effects can vary by the individual. If you're worried, go slow and share a can with a friend. Most guests see results like mild relaxation and creativity.
                        </div>
                    </div>
                </div>
                <div className="na-col-right">

                </div>
            </div>
        )
    }
    const layoutPL7 = () => {
        let beverages = thcMenu.core

        return (
            <div className="thc-giftcards-two-column-pl7">
                <div className="na-col-left">
                    <div className="thc-seltzers">
                    {beverages.map(item => (
                            <div className="thc-item">
                                <div className="thc-name">
                                    {item.vendor} {item.name} <span> • {item.price}</span>
                                </div>
                                <div className="thc-size">
                                    {item.size} • {item.type}
                                </div>
                                <div className="thc-description">
                                    {item.description}
                                </div>
                               
                            </div>
                        ))}
                    </div>
                    <div className="disclaimer">
                        <div className="thc-effects-headline">
                            First time?
                        </div>
                        <div className="thc-effects-text">
                            5mg of THC is considered to a be "low dose" but effects can vary by the individual. If you're worried, go slow and share a can with a friend. Most guests see results like mild relaxation and creativity.
                        </div>
                    </div>
                </div>
                <div className="na-col-right">

                </div>
            </div>
        )
    }
    const layoutPL8 = () => {
        let beverages = thcMenu.core

        return (
            <div className="thc-giftcards-two-column-pl8">
                <div className="na-col-left">
                    <div className="thc-seltzers">
                    {beverages.map(item => (
                            <div className="thc-item">
                                <div className="thc-name">
                                    {item.vendor} {item.name} <span> • {item.price}</span>
                                </div>
                                <div className="thc-size">
                                    {item.size} • {item.type}
                                </div>
                                <div className="thc-description">
                                    {item.description}
                                </div>
                               
                            </div>
                        ))}
                    </div>
                    <div className="disclaimer">
                        <div className="thc-effects-headline">
                            First time?
                        </div>
                        <div className="thc-effects-text">
                            5mg of THC is considered to a be "low dose" but effects can vary by the individual. If you're worried, go slow and share a can with a friend. Most guests see results like mild relaxation and creativity.
                        </div>
                    </div>
                </div>
                <div className="na-col-right">

                </div>
            </div>
        )
    }
    const layoutPL9 = () => {
        let beverages = thcMenu.edenPraire

        return (
            <div className="thc-giftcards-two-column-pl9">
                <div className="na-col-left">
                    <div className="thc-seltzers">
                    {beverages.map(item => (
                            <div className="thc-item">
                                <div className="thc-name">
                                    {item.vendor} {item.name} <span> • {item.price}</span>
                                </div>
                                <div className="thc-size">
                                    {item.size} • {item.type}
                                </div>
                                <div className="thc-description">
                                    {item.description}
                                </div>
                                
                            </div>
                        ))}
                    </div>
                    <div className="disclaimer">
                        <div className="thc-effects-headline">
                            First time?
                        </div>
                        <div className="thc-effects-text">
                            5mg of THC is considered to a be "low dose" but effects can vary by the individual. If you're worried, go slow and share a can with a friend. Most guests see results like mild relaxation and creativity.
                        </div>
                    </div>
                </div>
                <div className="na-col-right">

                </div>
            </div>
        )
    }

    const getLayout = () => {
        if (location === "pl1") {
            return (layoutPL1())
        } else if (location === 'pl2'){
            return (layoutPL2())
        } else if (location === 'pl3'){
            return (layoutPL3())
        } else if (location === 'pl4'){
            return (layoutPL4())
        } else if (location === 'pl5'){
            return (layoutPL5())
        } else if (location === 'pl6'){
            return (layoutPL6())
        } else if (location === 'pl7'){
            return (layoutPL7())
        } else if (location === 'pl8'){
            return (layoutPL8()) 
        } else if (location === 'pl9'){
            return (layoutPL9())
        }
    }

    return (
        <div>
            {getLayout()}
            
        </div>
    )
}
export default THC